import React from "react";
import { EuiIcon } from "@elastic/eui";

export const BooleanCellRenderer = (params: any) => {

  if (params.node.rowPinned) {
    return null;
  }
  
  let iconState = params.value === null ? null : (params.value === 1 || params.value);

  const getTrueIcon = () => {
    return (
      <EuiIcon type="check" color="green" size="m" />
    );
  };

  const getFalseIcon = () => {
    return (
      <EuiIcon type="cross" color="red" size="m" />
    );

  };

  const getNullIcon = () => {
    return (
      <EuiIcon type="empty" color="black" size="m" />
    );

  };
  
  return iconState === null ? getNullIcon() : (iconState ? getTrueIcon() : getFalseIcon());
};
